import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
          <img src="/images/Skiclub-Logo.png" alt="Logo" className='logo'/>
            
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Startseite
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/aktuelles'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Aktuelles
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/anfahrt'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Anfahrt
              </Link>
            </li>

            <li>
              <Link
                to='/mitgliedsantrag'
                className='nav-links-mobile'
                onClick={closeMobileMenu}
              >
                MITGLIED WERDEN
              </Link>
            </li>
          </ul>
          {button && <Button to='/mitgliedsantrag' buttonStyle='btn--outline'>MITGLIED WERDEN</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;